module.exports = __webpack_public_path__ + "img/1120354686.dcf1ebc0.png";